import { WEB_USER_URL } from 'constants/index'
import { logError, logWarn } from 'utils/logger'

/**
 * Ask web user to refresh its cached pages by tag (e.g. `['faq']`) after an admin change.
 * Fire-and-forget: never throws and never toasts — the admin action itself already succeeded.
 * Stale-while-revalidate: the first page visit afterwards still gets the old page.
 *
 * Plain fetch on purpose: the admin axios instance would add the admin token and base URL,
 * and an Authorization header would trigger a CORS preflight.
 */
export const revalidateWebUser = (tags: string[]): void => {
  if (!WEB_USER_URL) {
    logWarn('REACT_APP_WEB_USER_URL is not set, skip web user revalidate', tags)
    return
  }

  const query = new URLSearchParams()
  tags.forEach((tag) => query.append('tag', tag))
  const url = `${WEB_USER_URL.replace(/\/+$/, '')}/api/revalidate?${query.toString()}`

  void fetch(url, { method: 'POST' })
    .then((res) => {
      if (!res.ok) {
        logError('Web user revalidate failed', res.status, url)
      }
    })
    .catch((error) => logError('Web user revalidate failed', url, error))
}
